<div class="wrapper-group-accounts">
  <div class="wrapper-admin-preview">
    <span class="text-admin">{{'CHAT.admin' | translate}}</span>
    <div *ngFor="let admin of conversation?.admin_participants" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, admin.username]" class="wrapper-info-user">
      <div class="image-preview">
        <img *ngIf="admin.profile_photo_url === null" class="img-lister"
             [src]="(admin.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png'"
             alt="">
        <img *ngIf="admin.profile_photo_url !== null" [src]="admin.profile_photo_url" alt="">
      </div>
      <div class="wrapper-username">
        <span>{{admin.username}}</span>
        <img *ngIf="(admin.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../../../assets/icons/fill/icon-badge.svg" alt="">
        <img *ngIf="(admin.subscriptions | checkActiveRole) === UserRoles.company" src="../../../../../assets/icons/fill/icon-fill-company.svg" alt="">
      </div>
      <span class="user-name">{{admin.name}}</span>
      <button *ngIf="conversation.admin_participants !== undefined && conversation.admin_participants[0].id !== loggedUser.id" (click)="followUnfollowAdmin(admin.id)" class="custom-btn custom-btn--outline"><span>{{admin.am_i_following_this_user ? ('CHAT.unfollow' | translate) : ('GENERAL.follow' | translate)}}</span></button>
    </div>
  </div>
  <div class="wrapper-users-preview">
    <div *ngFor="let user of conversation?.non_admin_participants" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, user.username]" class="wrapper-info-user">
      <div class="image-preview">
        <img *ngIf="user.profile_photo_url === null" class="img-lister"
        [src]="(user.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png'"
        alt="">
        <img *ngIf="user.profile_photo_url !== null" [src]="user.profile_photo_url" alt="">
      </div>
      <div class="wrapper-username">
        <span>{{user.username}}</span>
        <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../../../assets/icons/fill/icon-badge.svg" alt="">
        <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.company" src="../../../../../assets/icons/fill/icon-fill-company.svg" alt="">
      </div>
      <span class="user-name">{{user.name}}</span>
      <button *ngIf="conversation.admin_participants[0].id !== loggedUser.id && user.id !== loggedUser.id" (click)="followUnfollowUser(user.id); $event.stopPropagation()" class="custom-btn custom-btn--outline">
        <span>{{user.am_i_following_this_user ? ('CHAT.unfollow' | translate) : ('GENERAL.follow' | translate)}}</span></button>
      <button *ngIf="conversation.admin_participants[0].id === loggedUser.id" (click)="removeUserFromGroup(user); $event.stopPropagation()" class="custom-btn custom-btn--outline"><span>{{'FOLLOWING_FOLLOWERS.remove' | translate}}</span></button>
    </div>
  </div>
</div>
